class EPMilestonesManager {
  constructor() {
    this.GIFT_FLAG = '_free_gift';
    this.SB_FLAG = '_shoppingbag';
    this.isUpdating = false;
    this.pendingSync = false;

    this.bindEvents();
    this.scheduleSync();
  }

  bindEvents() {
    document.addEventListener('on:cart:add', () => this.scheduleSync());
    document.addEventListener('on:cart:after-merge', () => this.scheduleSync());
    document.addEventListener('on:cart-drawer:after-open', () => this.scheduleSync());
  }

  scheduleSync() {
    if (this.pendingSync) return;
    this.pendingSync = true;
    setTimeout(() => {
      this.pendingSync = false;
      this.sync();
    }, 150);
  }

  async sync() {
    if (this.isUpdating) return;

    const bars = document.querySelectorAll('[data-ep-milestones]');
    if (!bars.length) return;

    this.isUpdating = true;

    try {
      const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());
      const totals = this.cartTotalsWithoutGifts(cart);

      bars.forEach((bar) => this.updateBar(bar, totals));
    } catch (err) {
      console.error('[EPMilestones] sync error:', err);
    } finally {
      this.isUpdating = false;
    }
  }

  cartTotalsWithoutGifts(cart) {
    let item_count = 0;
    let total_price = 0;
    cart.items.forEach((item) => {
      const isGift = item.properties && item.properties[this.GIFT_FLAG] === 'true';
      const isShoppingBag = item.properties && item.properties[this.SB_FLAG] === 'true';
      if (!isGift && !isShoppingBag) {
        item_count += item.quantity;
        total_price += item.final_line_price;
      }
    });
    return { item_count, total_price };
  }

  updateBar(bar, totals) {
    const type = bar.dataset.milestoneType;
    const milestones = bar.dataset.milestones
      .replace(/\s/g, '')
      .split('|')
      .map((v) => parseInt(v, 10))
      .filter((v) => !isNaN(v));

    const headlines = bar.dataset.headlines.split('|');
    const allUnlockedText = bar.dataset.allunlocked || '';

    const currentValue = type === 'value' ? totals.total_price : totals.item_count;

    // Trova la prossima milestone non raggiunta
    let nextMilestone = 0;
    let nextIndex = -1;
    let allUnlocked = true;

    for (let i = 0; i < milestones.length; i++) {
      if (currentValue < milestones[i]) {
        nextMilestone = milestones[i];
        nextIndex = i;
        allUnlocked = false;
        break;
      }
    }

    // Calcolo % progresso
    const lastMilestone = milestones[milestones.length - 1];
    let progressPercent;
    if (allUnlocked) {
      progressPercent = 100;
    } else {
      progressPercent = Math.min(100, (currentValue * 100) / lastMilestone);
    }

    // Calcolo headline
    let currentHeadline;
    if (allUnlocked) {
      currentHeadline = allUnlockedText;
    } else {
      const remaining = Math.max(0, nextMilestone - currentValue);
      const remainingDisplay = type === 'value' ? this.formatMoney(remaining) : String(remaining);
      const rawHeadline = headlines[nextIndex] || '';
      currentHeadline = rawHeadline.replace('{x}', remainingDisplay);
    }

    // Apply al DOM
    bar.classList.toggle('ep-milestones--unlocked', allUnlocked);

    const fill = bar.querySelector('[data-ep-milestones-fill]');
    if (fill) fill.style.width = progressPercent + '%';

    const headlineEl = bar.querySelector('[data-ep-milestones-headline]');
    if (headlineEl) headlineEl.textContent = currentHeadline;

    // Update step states
    const steps = bar.querySelectorAll('[data-ep-milestones-step]');
    steps.forEach((step) => {
      const stepValue = parseInt(step.dataset.stepValue, 10);
      step.classList.toggle('ep-milestones__step--reached', currentValue >= stepValue);
    });
  }

  formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents);
    }
    // Fallback semplice italiano
    return '€ ' + (cents / 100).toFixed(2).replace('.', ',');
  }
}

// Init
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new EPMilestonesManager());
} else {
  new EPMilestonesManager();
}